import { Box, Typography } from '@mui/material';
import { formatCurrency } from '@/utils';

interface Props {
    itemLabel: string;
    value?: string | number | null;
    formatAsCurrency?: boolean;
}

export default function QuoteItem({ itemLabel, value, formatAsCurrency = false }: Props) {
    const isDiscount = itemLabel === 'Discount on Legal Fee';

    let displayValue = value != null && value !== '' ? String(value) : undefined;
    if (displayValue !== undefined && formatAsCurrency) {
        displayValue = isDiscount ? `-$${formatCurrency(value)}` : `$${formatCurrency(value)}`;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
            }}
        >
            <Typography variant="body2">{itemLabel}</Typography>
            <Typography
                variant="labelMedium"
                sx={formatAsCurrency ? { fontWeight: isDiscount ? '700' : '500' } : undefined}
            >
                {displayValue}
            </Typography>
        </Box>
    );
}
